import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlanCategoryFormSchemaValues } from 'src/features/servicePlanCategory/utils/formSchema';
import { ServicePlanCategory } from 'src/features/servicePlanCategory/utils/types';

const RESOURCE = '/subscriptions/service-plan-category/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: ServicePlanCategoryFormSchemaValues): Promise<ServicePlanCategory> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateServicePlanCategory };
